import { LineQualityPage } from '@live-webinar/broadcast';
import { RouterType } from '@online-webinar/router';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/test-suite/line'].update({
        staticData: { title: { page: 'TestSuite.Chooser.Line.Title' } },
        component: authGuard(LineQualityPage)
    });
};
